import { NextPageWithLayout } from 'next';
import * as O from 'fp-ts/Option';
import SignIn from '@modules/auth/SignIn';
import { getStringQuery } from '@shared/utils/queries';

const SignInPage: NextPageWithLayout<{ referrer?: string }> = ({ referrer }) => <SignIn referrer={referrer} />;

SignInPage.getLayoutProps = () => ({ hideFooter: true });

SignInPage.getInitialProps = ctx => ({
  referrer: O.toUndefined(getStringQuery(ctx.query, 'referrer')),
});

export default SignInPage;
